var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h48v48H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.458 4.456a6.488 6.488 0 0 1 6.49 6.13l.01.37v7a1.5 1.5 0 0 1-2.986.204l-.014-.204v-7a3.488 3.488 0 0 0-3.212-3.488l-.288-.012H19.98V13c0 2.366-1.866 4.33-4.194 4.49l-.306.01-5.48-.001V37a3.488 3.488 0 0 0 3.211 3.488l.289.012h3a1.5 1.5 0 0 1 .204 2.986l-.204.014h-3a6.488 6.488 0 0 1-6.49-6.13L7 37V16.738c0-.264.014-.527.04-.787V16c0-.11.012-.217.034-.32a7.546 7.546 0 0 1 1.79-3.923l.313-.337 4.731-4.755a7.395 7.395 0 0 1 4.848-2.195l.462-.014h14.24zm-4.08 13.922.43.02a4.51 4.51 0 0 1 4.07 4.48v3.244l3.411.557a5.542 5.542 0 0 1 4.608 5.786l-.03.338-.722 5.808a5.548 5.548 0 0 1-5.447 4.827h-7.58a5.513 5.513 0 0 1-4.568-2.448l-3.873-5.81a4.292 4.292 0 0 1 .552-5.474 1.5 1.5 0 0 1 .179-.15l.024-.016.08-.071a4.343 4.343 0 0 1 4.444-.685l-.078-5.906a4.496 4.496 0 0 1 4.192-4.49l.308-.01zm-.028 3-.176.014a1.49 1.49 0 0 0-1.296 1.466L28 31.96c.018 1.346-1.61 2.033-2.562 1.08l-1.179-1.181a1.343 1.343 0 0 0-1.908-.01l-.085.069-.073.086c-.282.38-.333.888-.13 1.321l.103.18 3.877 5.816a2.51 2.51 0 0 0 2.075 1.117h7.565a2.542 2.542 0 0 0 2.486-2.205l.72-5.796a2.537 2.537 0 0 0-2.092-2.799l-4.66-.76a1.5 1.5 0 0 1-1.259-1.48v-4.52c0-.77-.598-1.42-1.285-1.488l-.243-.012zM16.335 8.5l-.292.276-4.733 4.753c-.288.294-.532.62-.729.97l4.899.001c.744 0 1.384-.578 1.486-1.3l.014-.2V8.046a4.34 4.34 0 0 0-.645.454z",
    fill: "#9EA2FA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDrag);
export default __webpack_public_path__ + "static/media/icons-drag.919ddaa69cae9990b740b01e8540be59.svg";
export { ForwardRef as ReactComponent };